import PropTypes from 'prop-types';

import { compose, getContext } from 'core/libs/recompose';

import Link from 'core/components/Link';
import Avatar from 'core/components/Avatar';
import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';
import modelPropTypes, { personAttributes } from 'core/utils/prop-types/model';

import styles from './index.styl';


function Redaction(props) {
  const {
    authors,
    mediaUrlPrefix,
    theme: {
      texts,
    },
  } = props;

  return (
    <div className={styles.redaction}>
      <style jsx>{`
        .${styles.jobTitle}
        .${styles.email}
          font ${texts.bodySmall.font}

        .link
          font ${texts.body.font}
          font-weight 700
      `}</style>
      {authors.map(author => {
        const {
          attributes: {
            avatar,
            name,
            job_title: jobTitle,
            email,
            slug,
          },
        } = author;

        const avatarImage = avatar?.attributes?.versions?.original;

        return (
          <div key={slug} className={styles.editor}>
            <Avatar
              src={avatarImage}
              size={110}
              isCircular
            />
            <div className={styles.content}>
              <Link to={`${mediaUrlPrefix || ''}/authors/${slug}`}>
                <span className='link'>{name}</span>
              </Link>
              <div className={styles.jobTitle}>{jobTitle}</div>
              <Link to={`mailto:${email}`} type='primary'>
                <span className={styles.email}>{email}</span>
              </Link>
            </div>
          </div>
        );
      })
      }
    </div>
  );
}

Redaction.propTypes = {
  authors: PropTypes.arrayOf(modelPropTypes(personAttributes)),
  theme: themePropTypes(`
    {
      texts: {
        bodySmall: {
          font
        },
        body: {
          font
        }
      },
    }
  `),
  mediaUrlPrefix: PropTypes.string,
};

export default compose(
  getContext({
    mediaUrlPrefix: PropTypes.string,
  }),
  withTheme,
)(Redaction);
